import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Process } from './process.model';
import * as ProcessActions from './process.actions';

export const processesFeatureKey = 'processes';

export interface State extends EntityState<Process> {
    // additional entities state properties
}

export const adapter: EntityAdapter<Process> = createEntityAdapter<Process>({
    selectId: (model: Process) => model?.ProcessID ?? 0
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const processReducer = createReducer(
    initialState,
    on(ProcessActions.upsertProcess, (state, action) =>
        adapter.upsertOne(action.process, state)
    ),
    on(ProcessActions.deleteProcess, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ProcessActions.clearProcess, state => adapter.removeAll(state))
);

export function reducer(state: State | undefined, action: Action) {
    return processReducer(state, action);
}
